export function addEmptyOption(options: Array<{ label: string; value: string }>) {
    return [{ label: 'Select...', value: '', disabled: true }, ...options];
}
